
import Asset from './element'
export default

	props: section: Object

	components: {Asset}

	computed:
		assets: ->
			image1 = @section.image1?[0]
			video1 = @section.video1?[0]
			libraryVideo1 = @section.libraryVideo1?[0]

			image2 = @section.image2?[0]
			video2 = @section.video2?[0]
			libraryVideo2 = @section.libraryVideo2?[0]

			asset1 = {
				image: image1,
				video: video1,
				libraryVideo: libraryVideo1
			}

			asset2 = {
				image: image2,
				video: video2,
				libraryVideo: libraryVideo2
			}


			return [
				asset1 if image1 or video1 or libraryVideo1
				asset2 if image2 or video2 or libraryVideo2
			].filter Boolean

		classes: -> [
			'two-column' if @assets.length > 1
			@section.maxWidth || 'max-w-medium'
		]

